export const zh = {
  button: '按钮',
  ads: '广告',
  techClosed: '维护中',
  soon: '即将推出',
  noSeats: '无座位',
  events: '活动与&nbsp;娱乐项目',
  showAll: '显示全部',
  reset: '重置',
  filterEmptyResult: '请选择其他参数，我们将为您找到合适的娱乐项目！',
  showMore: '显示更多',
  fieldRequired: '此字段为必填字段',
  fieldPasswordError: '密码必须包含数字和拉丁字母，且长度不少于 8 个字符',
  fieldEmailError: '电子邮箱格式不正确',
  fieldPhoneError: '电话号码格式不正确',
  fieldBirthdayError: '出生日期不能晚于今天',
  fieldFormatError: '字段填写格式不正确',
  fieldEmailDuplicate: '此电子邮箱已注册',
  fieldPhoneDuplicate: '该电话号码已被注册',
  fieldEmailNotFound: '未找到使用此电子邮箱的用户',
  fieldPasswordMismatch: '密码不匹配',
  fieldBirthdayNotChild: '收件人不能超过18岁',
  fieldError: '字段填写错误',
  map: '地图',
  objectParams: '场馆参数',
  home: '首页',
  placement: '住宿类型',
  qrShowCard: '显示卡片',
  qrSubtitle: '在游乐园入口处出示二维码即可获得或消费积分',
  qrCard: '折扣卡',
  qrError: '卡片无法扫描？',
  qrAlert: '如果卡片无法读取，请提供下方的<br />唯一数字代码：',
  searchAllResults: '所有搜索结果',
  ourSocials: '我们的社交媒体',
  workPeriod: '营业时间',
  ourAddress: '我们的地址',
  phone: '电话',
  successRegTitle: '您已成功<br>注册！',
  successRegDesc: '我们期待您在"梦想岛"的光临',
  at: '在',
  from: '从',
  to: '至',
  successRegHK: '参观Hello Kitty美容沙龙<br>需要为每位客人购买游乐园门票',
  toMain: '返回首页',
  main: '首页',
  objects: '设施',
  profile: '个人资料',
  more: '更多',
  forPrefix: '适用于',
  guestOne: '位客人',
  guestGenitive: '位客人',
  guestFew: '位客人',
  guestMany: '位客人',
  selectDate: '选择日期',
  dayMon: '周一',
  dayTue: '周二',
  dayWed: '周三',
  dayThu: '周四',
  dayFri: '周五',
  daySat: '周六',
  daySun: '周日',
  january: '一月',
  february: '二月',
  march: '三月',
  april: '四月',
  may: '五月',
  june: '六月',
  july: '七月',
  august: '八月',
  september: '九月',
  october: '十月',
  november: '十一月',
  december: '十二月',
  thematicZone: '主题区域',
  thematicZones: '主题区域',
  thematicZonesGenitive: '主题区域',
  restaurant: '餐厅',
  cafesAndRestaurants: '咖啡厅和餐厅',
  cafesAndRestaurantsGenitive: '咖啡厅和餐厅',
  themedShop: '主题商店',
  themedShops: '主题商店',
  themedShopsGenitive: '主题商店',
};
